import React, { Fragment } from 'react'
import { AsyncTypeahead, Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead'
import './style.scss'
import newReferralResource from './new-referral-resource.svg'
import { FetchRequest } from '@rails/request.js'

const Error = ({ error }) => {
  return <p className='inline-errors my-2'>{error}</p>
}

export default class ReferralTagTypeaheadInput extends React.Component {
  constructor(props) {
    super(props)

    let selectedTag = null
    if (props.selected) {
      selectedTag = { label: props.selected }
    }

    this.state = {
      isLoading: false,
      selectedTag,
      ...props
    }

    this._renderMenu = this._renderMenu.bind(this)
    this.handleNewTag = this.handleNewTag.bind(this)
  }

  handleNewTag(event, text) {
    event.target.closest('.rbt-menu').classList.add('d-none')

    this.setState({ selectedTag: { label: text } })
  }

  _renderMenu(results, menuProps, state) {
    const items = results.map((result, index) => (
      <Fragment key={result.value}>
        <MenuItem key={index} option={result} position={index}>
          <Highlighter search={state.text}>{result.label}</Highlighter>
        </MenuItem>
      </Fragment>
    ))

    return (
      <Menu {...menuProps}>
        {items}
        <div onClick={event => this.handleNewTag(event, state.text)} className='d-flex new-referral-tag'>
          <img src={newReferralResource} className='client-icon rounded-circle my-auto' />
          <span className='my-auto'>This is a new referral type</span>
        </div>
      </Menu>
    )
  }

  render() {
    const { options, disabled, selected, errors, placeholder, className, endpointUrl, isLoading, selectedTag } =
      this.state

    const handleOnChange = item => {
      let label = null
      if (item[0]) {
        label = item[0].label
      }

      this.setState({ selected: label, errors: null })

      const selectedTag = options.find(item => item.label === label)

      this.setState({ selectedTag })
    }

    return (
      <Fragment>
        <AsyncTypeahead
          placeholder={placeholder}
          id={'referral-tag'}
          renderMenu={this._renderMenu}
          filterBy={['label']}
          clearButton={!disabled}
          onChange={item => handleOnChange(item)}
          defaultInputValue={selected}
          className={className}
          minLength={1}
          inputProps={{ autoComplete: 'typeahead-input', id: this.props.id }}
          isLoading={isLoading}
          labelKey='label'
          onSearch={query => {
            this.setState({ isLoading: true })
            this.setState({ selectedTag: { label: query } })
            const url = `${endpointUrl}?q[name_cont]=${query}`
            const request = new FetchRequest('GET', url, { responseKind: 'json' })
            request.perform().then(async response => {
              if (response.ok) {
                const data = await response.json
                this.setState({
                  isLoading: false,
                  options: data
                })
              }
            })
          }}
          options={options}
        />
        {errors && <Error error={errors} />}
        {selectedTag && selectedTag.hasOwnProperty('value') && (
          <input type='hidden' value={selectedTag.value} name='client_referral[referral_tag_attributes][id]' />
        )}
        {selectedTag && (
          <input type='hidden' value={selectedTag.label} name='client_referral[referral_tag_attributes][name]' />
        )}
      </Fragment>
    )
  }
}
